module.exports = __webpack_public_path__ + "static/media/ic_discount.eac67536.svg";